export default "__VITE_ASSET__DsA9asZ0__"